document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("country-select");
    const currentFlag = document.getElementById("current-flag");
    const options = document.querySelector(".flag-options");
    
    console.log('🔍 DEBUG: Header country selector initialized');
    console.log('🔍 DEBUG: Select element:', select);
    console.log('🔍 DEBUG: Current flag button:', currentFlag);
    console.log('🔍 DEBUG: Options container:', options);
  
    if (!select || !currentFlag || !options) {
      console.error('❌ DEBUG: Missing header country selector elements');
      return;
    }

    // Toggle dropdown
    currentFlag.addEventListener("click", () => {
      console.log('🔍 DEBUG: Flag button clicked');
      const isHidden = options.hasAttribute('hidden');
      if (isHidden) {
        options.removeAttribute('hidden');
        options.style.display = "block";
        console.log('🔍 DEBUG: Dropdown opened');
      } else {
        options.setAttribute('hidden', '');
        options.style.display = "none";
        console.log('🔍 DEBUG: Dropdown closed');
      }
    });
  
    // When user clicks on a flag option - SAME FUNCTIONALITY AS ANNOUNCEMENT BAR
    options.querySelectorAll(".flag-option-item").forEach((item) => {
      item.addEventListener("click", () => {
        const value = item.getAttribute("data-value");
        console.log('🔍 DEBUG: Flag option clicked:', value);
        console.log('🔍 DEBUG: Current select value:', select.value);
        
        // Update the hidden select value
        select.value = value;
        console.log('🔍 DEBUG: Updated select value to:', select.value);
        
        // Submit the localization form - SAME AS ANNOUNCEMENT BAR
        console.log('🔍 DEBUG: Submitting localization form (same as announcement bar)...');
        select.form.submit();
      });
    });
  
    // Click outside to close dropdown
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".flag-dropdown")) {
        options.setAttribute('hidden', '');
        options.style.display = "none";
      }
    });
  });
  
  
  
  
  
  
  // document.addEventListener("DOMContentLoaded", () => {
  //   const navItems = document.querySelectorAll(".nav-item");
  //   const dropdowns = document.querySelectorAll(".dropdown-content");
  //   const backdrop = document.querySelector(".dropdown-backdrop");
  //   const searchBtn = document.querySelector(".search-btn");
  //   const searchModal = document.getElementById("searchModal");
  //   const mobileMenu = document.querySelector(".mobile-nav-menu");
  
  //   // === NAVIGATION DROPDOWNS ===
  //   navItems.forEach((item) => {
  //     item.addEventListener("click", (e) => {
  //       const targetId = item.getAttribute("data-modal");
  //       let isOpening = false;
  //       dropdowns.forEach((drop) => {
  //   if (drop.id === targetId) {
  //     const willOpen = !drop.classList.contains("active");
  //     drop.classList.toggle("active", willOpen);
  //     mobileMenu.classList.remove("active");
  //     if (willOpen) isOpening = true;
  
  //     // === Reset sidebar when productsModal opens ===
  //     if (drop.id === "productsModal" && willOpen) {
  //       document.querySelectorAll("#productsModal .products-sidebar li")
  //         .forEach((li) => li.classList.remove("active"));
  //       document.querySelectorAll("#productsModal .brands-panel")
  //         .forEach((panel) => panel.classList.remove("active"));
  
  //       // Activate default
  //       const defaultLi = document.querySelector('#productsModal .products-sidebar li[data-target="by-brand"]');
  //       const defaultPanel = document.getElementById("by-brand");
  
  //       if (defaultLi) defaultLi.classList.add("active");
  //       if (defaultPanel) defaultPanel.classList.add("active");
  //     }
  
  //     // === Reset sidebar when applicationsModal opens ===
  //     if (drop.id === "applicationsModal" && willOpen) {
  //       document.querySelectorAll("#applicationsModal .applications-sidebar li")
  //         .forEach((li) => li.classList.remove("active"));
  //       document.querySelectorAll("#applicationsModal .apps-panel")
  //         .forEach((panel) => panel.classList.remove("active"));
  
  //       // Activate default
  //       const defaultLi = document.querySelector('#applicationsModal .applications-sidebar li[data-target="foodandbeverage"]');
  //       const defaultPanel = document.getElementById("foodandbeverage");
  
  //       if (defaultLi) defaultLi.classList.add("active");
  //       if (defaultPanel) defaultPanel.classList.add("active");
  //     }
  //     if (drop.id === "engineeringModal" && willOpen) {
  //   document.querySelectorAll("#engineeringModal .products-sidebar li")
  //     .forEach((li) => li.classList.remove("active"));
  //   document.querySelectorAll("#engineeringModal .brands-panel")
  //     .forEach((panel) => panel.classList.remove("active"));
  
  //   // Activate default
  //   const defaultLi = document.querySelector('#engineeringModal .products-sidebar li[data-target="specificationcontent"]');
  //   const defaultPanel = document.getElementById("specificationcontent");
  
  //   if (defaultLi) defaultLi.classList.add("active");
  //   if (defaultPanel) defaultPanel.classList.add("active");
  // }
  //   } else {
  //     drop.classList.remove("active");
  //   }
  // });
  
  //       // show backdrop only for specific dropdowns
  //       if (targetId !== "resourcesModal" && targetId !== "companyModal") {
  //         backdrop.classList.toggle("active", isOpening);
  //       } else {
  //         backdrop.classList.remove("active");
  //       }
  
  //       e.stopPropagation(); // don’t bubble into document click
  //     });
  //   });
  
  //   const closeSearchBtn = document.querySelector(".close-btn-search");
  // if (closeSearchBtn) {
  //   closeSearchBtn.addEventListener("click", (e) => {
  //     e.stopPropagation(); // prevent bubbling
  //     searchModal.classList.remove("active");
  //     backdrop.classList.remove("active");
  //   });
  // }
  
  //   // === SEARCH BUTTON DROPDOWN ===
  //   if (searchBtn && searchModal) {
  //     searchBtn.addEventListener("click", (e) => {
  //       console.log("Search Btn clicked");
  
  //       const isActive = searchModal.classList.contains("active");
  
  //       // close all others first
  //       dropdowns.forEach((drop) => drop.classList.remove("active"));
  
  //       // toggle search modal
  //       searchModal.classList.toggle("active", !isActive);
  
  //       // backdrop ON when opening
  //       // backdrop.classList.toggle("active", !isActive);
  
  //       console.log("Now:", searchModal.className);
  
  //       e.stopPropagation(); // prevent immediate outside close
  //     });
  //   } else {
  //     console.warn("Search button or searchModal not found in DOM");
  //   }
  
  //   // === CLOSE IF CLICKING BACKDROP ===
  //   backdrop.addEventListener("click", () => {
  //     dropdowns.forEach((drop) => drop.classList.remove("active"));
  //     backdrop.classList.remove("active");
  //   });
  
  //   // === CLOSE IF CLICKING OUTSIDE ===
  //   document.addEventListener("click", (e) => {
  //     if (
  //       !e.target.closest(".navbar-center") &&
  //       !e.target.closest(".dropdown-content") &&
  //       !e.target.closest(".search-btn")
  //     ) {
  //       dropdowns.forEach((drop) => drop.classList.remove("active"));
  //       backdrop.classList.remove("active");
  //     }
  //   });
  // });
  
  
  
document.addEventListener("DOMContentLoaded", () => {
  // SOLUTION: Only block specific anchor tags that interfere with dropdown functionality
  // Allow all other links to work normally
  document.addEventListener('click', function(e) {
    // Only prevent anchor clicks that are specifically causing dropdown issues
    // This is much more targeted - only block if it's a nav item that should open dropdowns
    if (e.target.tagName === 'A' && 
        e.target.closest('.nav-item') &&
        e.target.getAttribute('data-modal')) {
      // Only prevent navigation items that have dropdown functionality
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);
    
    // 6. Monitor navigation attempts (removed due to error)
    
    const navItems = document.querySelectorAll(".nav-item");
    const dropdowns = document.querySelectorAll(".dropdown-content");
    // const backdrop = document.querySelector(".dropdown-backdrop");
    const searchBtn = document.querySelector(".search-btn");
    const searchModal = document.getElementById("searchModal");
    const mobileMenu = document.querySelector(".mobile-nav-menu");
    
    // === MOBILE MENU SPECIFIC HANDLING ===
    const mobileNavItems = document.querySelectorAll(".mobile-nav-menu-item.nav-item");
    
    mobileNavItems.forEach((item) => {
      const targetId = item.getAttribute("data-modal");
      const drop = document.getElementById(targetId);
      
      // Add click handler specifically for mobile navigation
      item.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        console.log("Mobile nav clicked:", targetId); // Debug log
        
        // Close all dropdowns first
        dropdowns.forEach((d) => {
          d.classList.remove("active");
          const correspondingItem = document.querySelector(`.nav-item[data-modal="${d.id}"]`);
          if (correspondingItem) {
            correspondingItem.classList.remove("active-item");
          }
        });
        
        // Open the target dropdown
        if (drop) {
          drop.classList.add("active");
          item.classList.add("active-item");
          console.log("Modal opened:", targetId); // Debug log
        } else {
          console.warn("Modal not found:", targetId); // Debug log
        }
        
        // Hide mobile menu
        if (mobileMenu) {
          mobileMenu.classList.remove("active");
        }
      });
    });
  
    // === NAVIGATION DROPDOWNS (CLICK + HOVER) ===
    navItems.forEach((item) => {
      // Skip mobile menu items as they are handled separately
      if (item.classList.contains("mobile-nav-menu-item")) {
        return;
      }
      
      const targetId = item.getAttribute("data-modal");
      const drop = document.getElementById(targetId);
  
      const openHandler = (e) => {
        let isOpening = false;
  
        dropdowns.forEach((d) => {
          const correspondingItem = document.querySelector(
            `.nav-item[data-modal="${d.id}"]`
          );
  
          if (d.id === targetId) {
            const willOpen = !d.classList.contains("active");
            d.classList.toggle("active", willOpen);
            mobileMenu?.classList.remove("active");
  
            // toggle bold state on nav item
            if (correspondingItem) {
              correspondingItem.classList.toggle("active-item", willOpen);
            }
  
            if (willOpen) isOpening = true;
  
            // === Reset sidebar when productsModal opens ===
            if (d.id === "productsModal" && willOpen) {
              document
                .querySelectorAll("#productsModal .products-sidebar li")
                .forEach((li) => li.classList.remove("active-subitem"));
              document
                .querySelectorAll("#productsModal .brands-panel")
                .forEach((panel) => panel.classList.remove("active"));
  
              const defaultLi = document.querySelector(
                '#productsModal .products-sidebar li[data-target="by-brand"]'
              );
              const defaultPanel = document.getElementById("by-brand");
  
              if (defaultLi) defaultLi.classList.add("active-subitem");
              if (defaultPanel) defaultPanel.classList.add("active");
            }
  
            // === Reset sidebar when applicationsModal opens ===
            if (d.id === "applicationsModal" && willOpen) {
              // Clear all sidebar states in applications modal
              document
                .querySelectorAll("#applicationsModal .products-sidebar li")
                .forEach((li) => {
                  li.classList.remove("active-subitem");
                  li.classList.remove("active");
                });
              document
                .querySelectorAll("#applicationsModal .apps-panel")
                .forEach((panel) => panel.classList.remove("active"));
              document
                .querySelectorAll("#applicationsModal .brands-panel")
                .forEach((panel) => panel.classList.remove("active"));

              // Set default state to Food & Beverage
              const defaultLi = document.querySelector(
                '#applicationsModal .products-sidebar li[data-target="foodandbeverage"]'
              );
              const defaultPanel = document.getElementById("foodandbeverage");

              if (defaultLi) {
                defaultLi.classList.add("active-subitem");
                defaultLi.classList.add("active");
              }
              if (defaultPanel) defaultPanel.classList.add("active");
            }
  
            // === Reset sidebar when engineeringModal opens ===
            if (d.id === "engineeringModal" && willOpen) {
              document
                .querySelectorAll("#engineeringModal .products-sidebar li")
                .forEach((li) => li.classList.remove("active-subitem"));
              document
                .querySelectorAll("#engineeringModal .brands-panel")
                .forEach((panel) => panel.classList.remove("active"));
  
              const defaultLi = document.querySelector(
                '#engineeringModal .products-sidebar li[data-target="specificationcontent"]'
              );
              const defaultPanel = document.getElementById("specificationcontent");
  
              if (defaultLi) defaultLi.classList.add("active-subitem");
              if (defaultPanel) defaultPanel.classList.add("active");
            }
          } else {
            d.classList.remove("active");
            if (correspondingItem) {
              correspondingItem.classList.remove("active-item");
            }
          }
        });
  
        // show backdrop only for specific dropdowns
        if (targetId !== "resourcesModal" && targetId !== "companyModal" && 
            targetId !== "resourcesModalMobile" && targetId !== "companyModalMobile") {
          // backdrop.classList.toggle("active", isOpening);
        } else {
          // backdrop.classList.remove("active");
        }

        // Only prevent default for THIS navigation button, not for other links
        if (e.target === item || item.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
  
      // Attach open on hover + click
      item.addEventListener("mouseenter", openHandler);
      item.addEventListener("click", openHandler);
  
      // Keep dropdown open when hovering inside it
      if (drop) {
        drop.addEventListener("mouseenter", () => {
          drop.classList.add("active");
          item.classList.add("active-item");
          // backdrop.classList.add("active");
        });

        // Only close dropdown when moving to another nav item or completely away
        drop.addEventListener("mouseleave", (e) => {
          const relatedTarget = e.relatedTarget;
          const isMovingToNavItem = relatedTarget && relatedTarget.closest('.nav-item');
          
          // Only close if moving to another nav item or completely away
          if (isMovingToNavItem || !relatedTarget) {
            drop.classList.remove("active");
            item.classList.remove("active-item");
            // backdrop.classList.remove("active");
          }
        });
      }

      // Don't close when leaving nav item - let dropdown handle its own closing
      // Only close if moving to another nav item
      item.addEventListener("mouseleave", (e) => {
        const relatedTarget = e.relatedTarget;
        const isMovingToNavItem = relatedTarget && relatedTarget.closest('.nav-item');
        
        // Only close if moving to another nav item
        if (isMovingToNavItem) {
          drop?.classList.remove("active");
          item.classList.remove("active-item");
          // backdrop.classList.remove("active");
        }
      });
    });
  
    // === SEARCH MODAL CLOSE BUTTON ===
    const closeSearchBtn = document.querySelector(".close-btn-search");
    if (closeSearchBtn) {
      closeSearchBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        searchModal.classList.remove("active");
        // backdrop.classList.remove("active");
      });
    }
  
    // === SEARCH BUTTON DROPDOWN ===
    if (searchBtn && searchModal) {
      searchBtn.addEventListener("click", (e) => {
        const isActive = searchModal.classList.contains("active");
        dropdowns.forEach((drop) => {
          drop.classList.remove("active");
          document
            .querySelector(`.nav-item[data-modal="${drop.id}"]`)
            ?.classList.remove("active-item");
        });
        searchModal.classList.toggle("active", !isActive);
        // backdrop.classList.toggle("active", !isActive);
        // Only prevent default for the search button itself, not for other links
        if (e.target === searchBtn || searchBtn.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    } else {
      console.warn("Search button or searchModal not found in DOM");
    }
  
    // === CLOSE IF CLICKING BACKDROP ===
    // backdrop.addEventListener("click", () => {
    //   dropdowns.forEach((drop) => {
    //     drop.classList.remove("active");
    //     document
    //       .querySelector(`.nav-item[data-modal="${drop.id}"]`)
    //       ?.classList.remove("active-item");
    //   });
    //   searchModal?.classList.remove("active");
    //   backdrop.classList.remove("active");
    // });
  
    // === CLOSE IF CLICKING OUTSIDE ===
    document.addEventListener("click", (e) => {
      if (
        !e.target.closest(".navbar-center") &&
        !e.target.closest(".dropdown-content") &&
        !e.target.closest(".search-btn")
      ) {
        dropdowns.forEach((drop) => {
          drop.classList.remove("active");
          document
            .querySelector(`.nav-item[data-modal="${drop.id}"]`)
            ?.classList.remove("active-item");
        });
        searchModal?.classList.remove("active");
        // backdrop.classList.remove("active");
      }
    });
  });
  
  


  
// divider


  const cartBtn = document.getElementById("cartBtn");
    const cartDropdown = document.getElementById("cartDropdown");
    
  document.addEventListener("DOMContentLoaded", () => {
    const cartBtn = document.getElementById("cartBtn");
    const cartDrawer = document.querySelector("cart-drawer"); // global
  
    if (cartBtn && cartDrawer) {
      cartBtn.addEventListener("click", () => {
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
        } else {
          console.warn("Cart drawer found but no open() method");
        }
      });
    } else {
      console.warn("Cart button or cart drawer not found in DOM");
    }
  });
  
    cartBtn.addEventListener("mouseenter", () => {
    cartDropdown.classList.add("active");
  });
  
  cartBtn.addEventListener("mouseleave", () => {
    cartDropdown.classList.remove("active");
  });
  
  cartDropdown.addEventListener("mouseenter", () => {
    cartDropdown.classList.add("active");
  });
  
  cartDropdown.addEventListener("mouseleave", () => {
    cartDropdown.classList.remove("active");
  });
  
    // Optional: close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!cartBtn.contains(e.target) && !cartDropdown.contains(e.target)) {
        cartDropdown.classList.remove("active");
      }
    });
  
  
  
  
  document.querySelectorAll('.products-sidebar li').forEach(item => {
    item.addEventListener('mouseover', () => {
      // Remove active class from all sidebar items
      document.querySelectorAll('.products-sidebar li').forEach(li => li.classList.remove('active'));
      item.classList.add('active');
  
      // Hide all panels
      document.querySelectorAll('.brands-panel').forEach(panel => panel.classList.remove('active'));
  
      // Show selected panel
      const target = item.getAttribute('data-target');
      document.getElementById(target).classList.add('active');
    });
  });
  
  
  document.addEventListener("DOMContentLoaded", () => {
    const menuBtn = document.querySelector(".res-menu-btn");
    const mobileMenu = document.querySelector(".mobile-nav-menu");
  
    if (menuBtn && mobileMenu) {
      menuBtn.addEventListener("click", () => {
        mobileMenu.classList.toggle("active");
      });
    }
  });
  
  
  function movePanels() {
    const isMobile = window.innerWidth <= 768;
  
    document.querySelectorAll(".dropdown-content.products-mega").forEach((modal) => {
      const panels = modal.querySelectorAll(".brands-panel");
      const brandsContainer = modal.querySelector(".products-brands");
  
      panels.forEach((panel) => {
        const target = panel.id;
        const mobileContainer = modal.querySelector(
          `li[data-target="${target}"] .mobile-panel`
        );
  
        if (isMobile) {
          if (mobileContainer && !mobileContainer.contains(panel)) {
            mobileContainer.appendChild(panel);
          }
        } else {
          if (brandsContainer && !brandsContainer.contains(panel)) {
            brandsContainer.appendChild(panel);
          }
        }
      });
    });
  }
  
  
  
  window.addEventListener("load", movePanels);
  window.addEventListener("resize", movePanels);
  
  document.querySelectorAll(".products-sidebar li").forEach((li) => {
    li.addEventListener("click", () => {
      const targetId = li.getAttribute("data-target");
      const targetPanel = document.getElementById(targetId);
  
      // Remove active from all
      document
        .querySelectorAll(".products-sidebar li")
        .forEach((el) => el.classList.remove("active"));
      document
        .querySelectorAll(".brands-panel")
        .forEach((panel) => panel.classList.remove("active"));
  
      // Activate clicked li + corresponding panel
      li.classList.add("active");
      if (targetPanel) targetPanel.classList.add("active");
    });
  });
  
  function setupSidebarInteractions() {
    const isMobile = window.innerWidth <= 768;
    const clearSidebarState = () => {
      document
        .querySelectorAll(".products-sidebar li")
        .forEach((el) => {
          el.classList.remove("active");
          el.classList.remove("active-subitem");
        });
      document
        .querySelectorAll(".brands-panel")
        .forEach((panel) => panel.classList.remove("active"));
      document
        .querySelectorAll(".apps-panel")
        .forEach((panel) => panel.classList.remove("active"));
    };
  
    document.querySelectorAll(".products-sidebar li").forEach((li) => {
      // Clean old listeners first
      li.replaceWith(li.cloneNode(true));
    });
  
    document.querySelectorAll(".products-sidebar li").forEach((li) => {
      const targetId = li.getAttribute("data-target");
      const targetPanel = document.getElementById(targetId);
  
      if (isMobile) {
        // === Mobile: CLICK to toggle
        li.addEventListener("click", () => {
          const isAlreadyActive = li.classList.contains("active");
          clearSidebarState();

          if (!isAlreadyActive) {
            li.classList.add("active");
            if (targetPanel) targetPanel.classList.add("active");
          }
        });
      } else {
        // === Desktop: HOVER to toggle
        li.addEventListener("mouseover", () => {
          // Clear all active states first - check for both class variations
          document.querySelectorAll(".products-sidebar li").forEach((el) => {
            el.classList.remove("active");
            el.classList.remove("active-subitem");
          });
          document.querySelectorAll(".brands-panel").forEach((panel) => panel.classList.remove("active"));
          document.querySelectorAll(".apps-panel").forEach((panel) => panel.classList.remove("active"));
          
          // Immediately activate the new item
          li.classList.add("active");
          if (targetPanel) targetPanel.classList.add("active");
        });
        
        // Add mouseleave to ensure cleanup - only when moving to another tab
        li.addEventListener("mouseleave", (e) => {
          const relatedTarget = e.relatedTarget;
          // Only clear if moving to another sidebar item (not when leaving the sidebar area)
          if (relatedTarget && relatedTarget.closest('.products-sidebar li')) {
            // Clear states immediately - check for both class variations
            document.querySelectorAll(".products-sidebar li").forEach((el) => {
              el.classList.remove("active");
              el.classList.remove("active-subitem");
            });
            document.querySelectorAll(".brands-panel").forEach((panel) => panel.classList.remove("active"));
            document.querySelectorAll(".apps-panel").forEach((panel) => panel.classList.remove("active"));
          }
        });
      }
    });
  }
  
  // Run on load + resize
  window.addEventListener("load", setupSidebarInteractions);
  window.addEventListener("resize", setupSidebarInteractions);
  
  
  document.addEventListener("DOMContentLoaded", () => {
    const backButtons = document.querySelectorAll(".mobile-main-manu-header");
    // const backdrop = document.querySelector(".dropdown-backdrop");
    const mobileMenu = document.querySelector(".mobile-nav-menu");
  
    backButtons.forEach((backBtn) => {
      backBtn.addEventListener("click", () => {
        // Close only the dropdown that contains THIS backBtn
        const parentDropdown = backBtn.closest(".dropdown-content");
        if (parentDropdown) {
          parentDropdown.classList.remove("active");
        }
  
        // Instead of fully closing, show the mobile menu
        if (mobileMenu) {
          mobileMenu.classList.add("active");
        }
  
        // Keep backdrop visible since menu is still open
        // if (backdrop) {
        //   backdrop.classList.add("active");
        // }
      });
    });
  });
  
  
  
  